import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useEffect } from 'react';
import LoadingBlock from '../Common/LoadingBlock';
import MeetingSelector from './MeetingSelector';
import MeetingWarning from './MeetingWarning';
import useMeetings, { useSelectedMeeting, useSelectedMeetingCalendar, } from './hooks/useMeetings';
import HubspotWrapper from '../Common/HubspotWrapper';
import ErrorHandler from '../Common/ErrorHandler';
import { pluginPath } from '../../constants/leadinConfig';
import { __ } from '@wordpress/i18n';
import Raven from 'raven-js';
export default function MeetingController({ handleChange, url, }) {
    const { mappedMeetings: meetings, loading, error, reload, connectCalendar, } = useMeetings();
    const selectedMeetingOption = useSelectedMeeting(url);
    const selectedMeetingCalendar = useSelectedMeetingCalendar(url);
    useEffect(() => {
        if (!url && meetings.length > 0) {
            handleChange(meetings[0].value);
        }
    }, [meetings, url, handleChange]);
    const handleLocalChange = (option) => {
        handleChange(option.value);
    };
    const handleConnectCalendar = () => {
        return connectCalendar()
            .then(() => {
            reload();
        })
            .catch(error => {
            Raven.captureMessage('Unable to connect calendar', {
                extra: { error },
            });
        });
    };
    return (_jsx(Fragment, { children: loading ? (_jsx(LoadingBlock, {})) : error ? (_jsx(ErrorHandler, { status: (error && error.status) || error, resetErrorState: () => reload(), errorInfo: {
                header: __('There was a problem retrieving your meetings', 'leadin'),
                message: __('Please refresh your meetings or try again in a few minutes.', 'leadin'),
                action: __('Refresh meetings', 'leadin'),
            } })) : (_jsxs(HubspotWrapper, { padding: "90px 32px 24px", pluginPath: pluginPath, children: [selectedMeetingCalendar && (_jsx(MeetingWarning, { status: selectedMeetingCalendar, onConnectCalendar: handleConnectCalendar })), meetings.length > 1 && (_jsx(MeetingSelector, { onChange: handleLocalChange, options: meetings, value: selectedMeetingOption }))] })) }));
}
